// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-sidebar .title-info{margin-top:20px;padding-top:20px;border-top:1px solid #1c252f}.title-sidebar .sync-watchList-btn{background-color:#303740!important;min-height:48px}.text-recommendations{margin-bottom:16px}", ""]);
// Exports
module.exports = exports;
